export const IMAGE_FILE_TYPES = ['gif', 'jpg', 'jpeg', 'png'];
